import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class DeskWithComputer extends DestroyableObstacle {
	static key = "DeskWithComputer";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.PLASTIC_DEBRIS;
	}

	static deserialize(data: any): DeskWithComputer {
		const d = new DeskWithComputer(deserializeXY(data.xy));
		d.restoreBaseFields(data);
		return d;
	}
}
